import { SxProps } from '@mui/material';

import { useMytaverse } from '@providers/MytaverseProvider';
import { colors } from '@constants/colors';

export const useStyles = () => {
  const { appTheme } = useMytaverse();

  return {
    root: {
      '& .MuiBackdrop-root': {
        backgroundColor: '#00000066',
        backdropFilter: ' blur(12px)',
      },
    },
    container: {
      display: 'flex',
      gap: 0,
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'start',
      padding: '22px 35px 22px 55px',
      height: 750,
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 953,

      background: colors.white,

      borderRadius: '30px',
      maxHeight: '90vh',
      maxWidth: '90vw',
      overflow: 'auto',

      '&:focus-visible': {
        outline: 'none',
      },

      '@media (max-width: 991px)': {
        padding: '20px 12px 20px 44px',
        width: '90%',
        height: '90%',
        maxHeight: '90dvh',
        maxWidth: '90dvw',
        borderRadius: '20px',
      },
    } as SxProps,
    closeIcon: {
      position: 'absolute',
      top: 34,
      right: 32,
      color: '#939393',
      fontSize: 14,
      cursor: 'pointer',

      '@media (max-width: 991px)': {
        top: 24,
        right: 22,
      },
    },
    iconContainer: {
      display: 'flex',
      background: appTheme.mainColor,
      borderRadius: '50%',
      padding: 1,
      '& svg': {
        color: colors.white,
        width: 24,
        height: 24,
      },
      '@media (max-width: 991px)': {
        marginRight: '32px',
      },
    },
    title: {
      fontFamily: 'var(--primary-font-medium)',
      // fontWeight: 700,
      fontSize: 40,
      lineHeight: 1.4,
      color: colors.black,
      marginTop: 0.75,
      letterSpacing: '0.01em',

      '@media (max-width: 991px)': {
        fontSize: 24,
        lineHeight: 1.4,
        width: 'calc(100% + 56px)',
        marginRight: '-12px',
        marginLeft: '-44px',
        paddingRight: '44px',
        paddingLeft: '44px',
        textAlign: 'center',
      },
    },
    pdf: {
      position: 'relative',
      overflow: 'auto',
      width: '100%',
      minHeight: '150px',
      alignItems: 'center',
      marginBottom: 2,

      '&::-webkit-scrollbar': {
        height: '5px',
        width: '5px',
      },

      '&::-webkit-scrollbar-track': {
        backgroundColor: colors.silver,
        borderRadius: '2px',
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: appTheme.mainColor,
        borderRadius: '2px',
        boxShadow: 'unset',
      },
    },
    overlay: {
      position: 'sticky',
      bottom: 0,
      left: 0,
      right: 0,
      height: '30%',
      background:
        'linear-gradient(180.1deg, rgba(255, 255, 255, 0) 0.09%, #FFFFFF 70%)',
    },

    button: {
      padding: '14px 32px',
      width: 'fit-content',
      maxWidth: '100%',
      fontWeight: 500,
      borderRadius: '99px',
      fontSize: 20,
      lineHeight: '140%',
      color: colors.white,
      backgroundColor: appTheme.mainColor,
      textTransform: 'none',
      marginTop: 'auto',

      '&:hover': {
        backgroundColor: appTheme.mainColor,
      },

      '&:disabled': {
        color: colors.white,
        background: colors.grey_third,
        cursor: 'no-drop',
      },
    },
  };
};
